import React, { useEffect, useState } from 'react'
import { useMediaQuery } from "@mui/material"
import { useHistory } from 'react-router-dom';
import { Desktop } from "./Desktop"
import { Mobile } from "./Mobile";

export const Header = () => {
    const desktop = useMediaQuery('(min-width:1025px)');
    const history = useHistory()
    const [open, setOpen] = useState(false) 
   
    const registration = () => {
        window.location.href = process.env.REACT_APP_URL_PM + '/biz/registration';
    }

    const login = () => {
        window.location.href = process.env.REACT_APP_URL_PM + '/biz/login';
    }

    const navFeature = [
        {name:'Home', to:'home'},
        {name:'Benefits', to:'benefits'},
        {name:'All Apps Free', to:'allappsfree'},
        {name:'Testimonials', to:'testimonials'},
        {name:'Contact Us', to:'contactus'},
    ]

    const [divID, setDivID] = useState('home');
    const handleScroll = React.useMemo(() => {
        return function(){
            const divElements = navFeature.map(v => document.getElementById(v.to));
            const visibleDiv = divElements.find(div => {
                if (div) {
                    const rect = div.getBoundingClientRect();
                    return rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2;
                }
                return false
            });
            if (visibleDiv) {
                setDivID(visibleDiv.id === undefined ? 'contactus' : visibleDiv.id);
            }
        }
         // eslint-disable-next-line
    }, [])


    useEffect(() => {
        if (history.location.pathname !== '/contact-us') {
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }else{
            setDivID('contactus')
        }
        // eslint-disable-next-line
    }, [])
    
    const [names, setNames] = useState('')
    useEffect(() => {
        if (names !== '') {
            document.getElementsByClassName(`call-${names}`)[0].click();
        }
        // eslint-disable-next-line
    }, [names])

    const HandleClickTC = () => {
        setOpen(!open)
    }

    const handleClickContactUs = (to) => {
        setNames(to)
        setOpen(false)
        if (to === 'contactus') {
            setDivID('contactus')
            history.push('/contact-us')
        }else{
            history.push('/')
            setDivID(to)
        }
    }

    const redirectHandler = () => {
        try {
            window.open(process.env.REACT_APP_URL_PSL, '_blank').focus()
        } catch (error) {    
            window.location.href = process.env.REACT_APP_URL_PSL;
        }
    }
 
    return (
        desktop ? <Desktop divID={divID} navFeature={navFeature} open={open} setOpen={setOpen} registration={registration} login={login} redirectHandler={redirectHandler} handleClickContactUs={handleClickContactUs} HandleClickTC={HandleClickTC} /> : <Mobile divID={divID} navFeature={navFeature} open={open} setOpen={setOpen} registration={registration} login={login} redirectHandler={redirectHandler} handleClickContactUs={handleClickContactUs} HandleClickTC={HandleClickTC}/>
    )
}